import React, { useMemo, useState } from 'react';
import {
  AreaChart,
  Area,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Legend,
  LabelList
} from 'recharts';

const DEFAULT_SERIES = {
  total: true,
  google: true,
  meta: true,
  other: true
};

const LeadsLineChart = ({ data = [] }) => {
  const [visible, setVisible] = useState(DEFAULT_SERIES);

  const legendPayload = useMemo(
    () => [
      { value: 'Total', dataKey: 'total', color: '#2563eb' },
      { value: 'Google', dataKey: 'google', color: '#10b981' },
      { value: 'Meta', dataKey: 'meta', color: '#f59e0b' },
      { value: 'Other', dataKey: 'other', color: '#8b5cf6' }
    ],
    []
  );

  const toggleSeries = (dataKey) => {
    setVisible((prev) => ({ ...prev, [dataKey]: !prev[dataKey] }));
  };

  return (
    <div className="rounded-2xl bg-white shadow-sm border border-gray-100 p-4 h-[360px]">
      <div className="mb-4">
        <h3 className="text-sm font-semibold text-gray-900">Leads Over Time</h3>
      </div>
      <ResponsiveContainer width="100%" height="88%">
        <AreaChart data={data}>
          <defs>
            <linearGradient id="leadTotalGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#2563eb" stopOpacity={0.3} />
              <stop offset="95%" stopColor="#2563eb" stopOpacity={0.06} />
            </linearGradient>
            <linearGradient id="leadGoogleGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#10b981" stopOpacity={0.22} />
              <stop offset="95%" stopColor="#10b981" stopOpacity={0.04} />
            </linearGradient>
            <linearGradient id="leadMetaGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#f59e0b" stopOpacity={0.22} />
              <stop offset="95%" stopColor="#f59e0b" stopOpacity={0.04} />
            </linearGradient>
            <linearGradient id="leadOtherGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#8b5cf6" stopOpacity={0.22} />
              <stop offset="95%" stopColor="#8b5cf6" stopOpacity={0.04} />
            </linearGradient>
          </defs>
          <CartesianGrid stroke="#f1f5f9" strokeDasharray="3 3" />
          <XAxis dataKey="label" tick={{ fontSize: 11, fill: '#64748b' }} />
          <YAxis tick={{ fontSize: 11, fill: '#64748b' }} />
          <Tooltip />
          <Legend
            verticalAlign="top"
            align="right"
            height={24}
            wrapperStyle={{ fontSize: 11, cursor: 'pointer' }}
            payload={legendPayload.map((item) => ({
              ...item,
              inactive: !visible[item.dataKey]
            }))}
            onClick={(e) => toggleSeries(e.dataKey)}
          />
          <Area type="monotone" dataKey="total" name="Total" stroke="#2563eb" fill="url(#leadTotalGradient)" strokeWidth={2.5} animationDuration={700} hide={!visible.total}>
            <LabelList dataKey="total" position="top" style={{ fill: '#1e3a8a', fontSize: 9 }} />
          </Area>
          <Area type="monotone" dataKey="google" name="Google" stroke="#10b981" fill="url(#leadGoogleGradient)" strokeWidth={2} animationDuration={700} hide={!visible.google}>
            <LabelList dataKey="google" position="top" style={{ fill: '#065f46', fontSize: 9 }} />
          </Area>
          <Area type="monotone" dataKey="meta" name="Meta" stroke="#f59e0b" fill="url(#leadMetaGradient)" strokeWidth={2} animationDuration={700} hide={!visible.meta}>
            <LabelList dataKey="meta" position="top" style={{ fill: '#92400e', fontSize: 9 }} />
          </Area>
          <Area type="monotone" dataKey="other" name="Other" stroke="#8b5cf6" fill="url(#leadOtherGradient)" strokeWidth={2} animationDuration={700} hide={!visible.other}>
            <LabelList dataKey="other" position="top" style={{ fill: '#4c1d95', fontSize: 9 }} />
          </Area>
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default LeadsLineChart;
